import { render, staticRenderFns } from "./TestMethod.vue?vue&type=template&id=2fdf9c39&scoped=true&"
import script from "./TestMethod.vue?vue&type=script&lang=js&"
export * from "./TestMethod.vue?vue&type=script&lang=js&"
import style0 from "./TestMethod.vue?vue&type=style&index=0&id=2fdf9c39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdf9c39",
  null
  
)

export default component.exports